import includes from 'ramda/src/includes'
import pipe from 'ramda/src/pipe'
import userGroupsSelector from 'root/src/client/logic/auth/selectors/userGroupsSelector'

export default pipe(
	userGroupsSelector,
	includes('admin'),
)
